import { isValidElement as o } from "react";
import { getButtonIconSize as r } from "./Button.styles.js";
const i = ({
  icon: t,
  size: e
}) => {
  const n = r(e);
  return typeof t == "function" ? t({
    hasWrapper: !1,
    size: n
  }) : o(t) ? t : null;
};
i.displayName = "ButtonIcon";
export {
  i as ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
